export default [
  { value: 'public', text: 'Público' },
  { value: 'reserved', text: 'Reservado' },
  { value: 'secret', text: 'Secreto' }
];
